export type PolicyCoverages = {
  LOIAccidentInd: boolean;
  LOIInlandMarineInd: boolean;
  LOIGeneralLiabilityInd: boolean;
  LOIProfessionalLiabilityInd: boolean;
  LOIPropertyInd: boolean;
  LOISexualAbuseMolestationInd: boolean;
  LOIManagementLiabilityInd: boolean;
  LOIErrorsAndOmissionsInd: boolean;
  LOIExcessLiabilityInd: boolean;
};

export const PolicyCoveragesCodeNames = [
  'LOIAccidentInd',
  'LOIGeneralLiabilityInd',
  'LOIInlandMarineInd',
  'LOIPropertyInd',
  'LOIProfessionalLiabilityInd',
  'LOISexualAbuseMolestationInd',
  'LOIManagementLiabilityInd',
  'LOIErrorsAndOmissionsInd',
  'LOIExcessLiabilityInd',
];

export const insuranceLineIds = {
  LOIAccidentInd: 'clb5i1mxt0002ukv5170yg5o3',
  LOIGeneralLiabilityInd: 'cl1ff96gu02ixgffg52rnesj2',
  LOIInlandMarineInd: 'clb5i1mxt0002ukv5170yg5o5',
  LOIPropertyInd: 'cl1ff96gu01ixgffg52rnesj3',
  LOIProfessionalLiabilityInd: 'cleq6doh00000zrv5frlh9cep',
  LOISexualAbuseMolestationInd: 'clb5i1mxt0002ukv5170yg5o4',
  LOIManagementLiabilityInd: 'clb5i1mxt0002ukv5170yg5o9',
  LOIErrorsAndOmissionsInd: 'clb5i1mxt0002ukv5170yg510',
  LOIExcessLiabilityInd: 'clua8zfpt000108ld5wdad9xm',
};
